<cx-icon [type]="iconType"></cx-icon><span>{{ 'rfp.machineInfo.hint' | cxTranslate }}</span>
